"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useBeginESignProcessService = void 0;
const hooks_1 = require("../../hooks");
const useBeginESignProcessService = (repository) => {
    const { call: beginESignProcessCall, isLoading: isBeginESignProcessLoading, isSuccess: isBeginESignProcessSuccess, data: beginESignProcessData, isError: isBeginESignProcessError, } = (0, hooks_1.useAsyncStateInfo)(repository.beginESignProcess);
    return {
        beginESignProcessCall,
        isBeginESignProcessLoading,
        isBeginESignProcessSuccess,
        beginESignProcessData,
        isBeginESignProcessError,
    };
};
exports.useBeginESignProcessService = useBeginESignProcessService;
//# sourceMappingURL=useBeginESignProcessService.hook.js.map